var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClsoedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.238,
    height: 21.241,
    viewBox: "0 0 20.238 21.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(-3.264 -1.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23686",
    "data-name": "Path 23686",
    d: "M22.5,12.462,23.487,9.4A.352.352,0,0,0,23.356,9l-2.6-1.9-1-3.057a.355.355,0,0,0-.335-.243L16.2,3.793,13.588,1.909a.349.349,0,0,0-.408,0L10.566,3.793l-3.219.014a.355.355,0,0,0-.335.243l-1,3.057L3.411,9a.352.352,0,0,0-.13.391l.986,3.067L3.28,15.53a.352.352,0,0,0,.13.391l2.6,1.9,1,3.057a.355.355,0,0,0,.335.243l3.219.014,2.613,1.884a.345.345,0,0,0,.408,0L16.2,21.132l3.219-.014a.355.355,0,0,0,.335-.243l1-3.057,2.6-1.9a.352.352,0,0,0,.13-.391Zm-2.778,0a6.339,6.339,0,1,1-6.339-6.339,6.339,6.339,0,0,1,6.339,6.339Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 1.409,
    cy: 1.409,
    r: 1.409,
    transform: "translate(9.862 8.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 1.409,
    cy: 1.409,
    r: 1.409,
    transform: "translate(14.088 13.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23687",
    "data-name": "Path 23687",
    d: "M28.951,24.827l-4.2,4.25a1.1,1.1,0,0,1-1.553.007,1.116,1.116,0,0,1-.32-.778,1.073,1.073,0,0,1,.327-.775l4.25-4.2a1.092,1.092,0,0,1,1.493,0A1.066,1.066,0,0,1,28.951,24.827Z",
    transform: "translate(-12.708 -13.731)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClsoedIcon);
export default __webpack_public_path__ + "static/media/clsoedIcon.c4fc996efc24246a1c7ae09c9907ac8d.svg";
export { ForwardRef as ReactComponent };